/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ExternalLinkSquareAltIconConfig = {
  name: 'ExternalLinkSquareAltIcon',
  height: 512,
  width: 448,
  svgPath: 'M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(ExternalLinkSquareAltIconConfig);